import { repository } from '@/api/base'

export default {
  async getAuditoryNumber() {
    const { data } = await repository.get('/view/auditoryNumber')
    return data
  },

  async getDayName() {
    const { data } = await repository.get('/view/dayName')
    return data
  },

  async getDepartmentName() {
    const { data } = await repository.get('/view/departmentName')
    return data
  },

  async getGroupTypeName() {
    const { data } = await repository.get('/view/groupTypeName')
    return data
  },

  async getLectorName() {
    const { data } = await repository.get('/view/lectorName')
    return data
  },

  async getLocationAddress() {
    const { data } = await repository.get('/view/locationAddress')
    return data
  },

  async getPairTime() {
    const { data } = await repository.get('/view/pairTime')
    return data
  },

  async getStudyGroup() {
    const { data } = await repository.get('/view/studyGroup')
    return data
  },

  async getSubgroup() {
    const { data } = await repository.get('/view/subgroup')
    return data
  },

  async getSubjectName() {
    const { data } = await repository.get('/view/subjectName')
    return data
  },

  async getWeekNumber() {
    const { data } = await repository.get('/view/weekNumber')
    return data
  },

  async getLessonType() {
    const { data } = await repository.get('/view/lessonType')
    return data
  },

  async getGroupStream() {
    const { data } = await repository.get('/view/groupStream')
    return data
  },

  async getSpeciality() {
    const { data } = await repository.get('/view/speciality')
    return data
  },

  async getAcademicYear() {
    const { data } = await repository.get('/view/academicYear')
    return data
  },

  async getCourseNumber() {
    const { data } = await repository.get('/view/courseNumber')
    return data
  },

  async getSemester() {
    const { data } = await repository.get('/view/semester')
    return data
  },

  async getPivotField() {
    const { data } = await repository.get('/dictionary/pivotField/findAll')
    return data
  }
}
